var _excluded = ["href", "dispatch", "className", "children", "primary", "inverted", "language", "enableLoader", "loading", "htmlType", "target", "forwardRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gtm from '../../helpers/gtm';
import { isExternalLink, isHashLink } from '../../helpers/link';
import withMapping from '../../Context/withMapping';
import './style.scss';
export var Button = function Button(_ref) {
  var href = _ref.href,
    dispatch = _ref.dispatch,
    className = _ref.className,
    children = _ref.children,
    primary = _ref.primary,
    inverted = _ref.inverted,
    language = _ref.language,
    enableLoader = _ref.enableLoader,
    loading = _ref.loading,
    htmlType = _ref.htmlType,
    target = _ref.target,
    forwardRef = _ref.forwardRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames('Button', className, {
    'Button--primary': primary,
    'Button--inverted': inverted,
    'is-loading': loading
  });
  var onClick = function onClick(event) {
    if (loading) return;

    // Using element.innerText gives us purely the text of the element which is
    // perfect for the tracking event. We don't want a string containing HTML.
    var text = event.target ? event.target.innerText : 'Unknown';
    gtm.trackUserEvent('button', 'click', text, href);
    if (props.onClick) {
      props.onClick(event);
    }
  };
  if (!href) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/button-has-type
      React.createElement("button", _extends({
        type: htmlType,
        className: classes,
        href: href
      }, props, {
        ref: forwardRef,
        onClick: onClick
      }), children)
    );
  }
  if (isExternalLink(href)) {
    return /*#__PURE__*/React.createElement("a", _extends({
      className: classes,
      href: href,
      target: "_blank",
      rel: "noreferrer noopener"
    }, props, {
      ref: forwardRef,
      onClick: onClick
    }), children);
  }
  if (isHashLink(href)) {
    return /*#__PURE__*/React.createElement("a", _extends({
      className: classes,
      href: href,
      target: target,
      rel: "noreferrer noopener"
    }, props, {
      ref: forwardRef,
      onClick: onClick
    }), children);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({
    to: href,
    className: classes,
    target: target
  }, props, {
    ref: forwardRef,
    onClick: onClick
  }), children);
};
Button.defaultProps = {
  primary: true,
  inverted: false,
  disabled: false,
  href: null,
  enableLoader: false,
  htmlType: 'button',
  target: '_self',
  forwardRef: null
};
Button.propTypes = {
  href: PropTypes.string,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  inverted: PropTypes.bool,
  enableLoader: PropTypes.bool,
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  forwardRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.element
  })])
};
export default withMapping(Button);